/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconLetterU = createReactComponent("letter-u", "IconLetterU", [
  ["path", { d: "M6 4v11a5 5 0 0 0 5 5h2a5 5 0 0 0 5 -5v-11", key: "svg-0" }]
]);

export { IconLetterU as default };
//# sourceMappingURL=IconLetterU.js.map
